import { Modal } from "../Modal";

/**
 * A photo of a paper, large, in the house modal — an expense's receipt
 * (G-135) and a delivery's document (G-137). The caller owns the blob URL and
 * revokes it in `onClose`.
 */
export function PhotoViewer({
  title,
  url,
  alt,
  onClose,
}: {
  title: string;
  url: string;
  alt: string;
  onClose: () => void;
}) {
  return (
    <Modal title={title} onClose={onClose}>
      <img src={url} alt={alt} className="photo-viewer-img" />
    </Modal>
  );
}
